import { useMutation } from '@tanstack/react-query';
import axiosInstance from '../../axiosConfig';

const previewMapping = async ({ mappingId, product }) => {
  const body = product ? { product } : {};

  try {
    const response = await axiosInstance.post(
      `/mappings/${mappingId}/preview/`,
      body
    );
    return response.data;
  } catch (error) {
    console.error('preview mapping API error:', error);
    throw error;
  }
};

export const usePreviewMapping = () => {
  const mutation = useMutation({
    mutationFn: previewMapping,
  });

  return {
    previewMapping: mutation.mutateAsync,
    isLoading: mutation.isPending,
    error: mutation.error,
    data: mutation.data,
  };
};
